import { urls } from '../constants'
import { remove } from '@user/store/services/crud'
import { toast } from '@sales-center/components'
import { deleteActivity } from '../state'

export async function deleteActivityEffect(id: number) {
  const response = await remove(urls.delete(id))

  if (!response.ok) {
    toast.error('Failed to remove Activity')

    return deleteActivity(-1)
  }

  return deleteActivity(id)
}
